module.exports = __webpack_public_path__ + "img/438.aef865ab.jpg";